import * as React from 'react'
import moment from 'moment'
import { Chart, Axis, Tooltip, Geom } from 'bizcharts'
import { LoadingAnimation } from '../../../../../../components/LoadingAnimation'
import { InventoryLogStore } from './InventoryLogStore'
import { observer } from 'mobx-react'

interface Props {
  companyId: number
  locationId: number
  productId: string
  defaultQuantity: number
  inventoryLogStore: InventoryLogStore
}

@observer
export class InventoryLogGraph extends React.Component<Props, {}> {
  componentDidMount() {
    const { inventoryLogStore } = this.props
    inventoryLogStore.getInventoryGraphLogs()
  }

  render() {
    const { inventoryLogStore } = this.props
    const pastWeekInventoryLogs = inventoryLogStore.pastWeekInventoryLogs

    if (!pastWeekInventoryLogs) {
      return <LoadingAnimation />
    }

    // Group by 14 days
    const last14days = [...new Array(14)]
      .map((i, index) => moment().startOf('day').subtract(index, 'days'))
      .reverse()
    const dayData: Array<{ date: string; quantity: number }> = []
    last14days.forEach((day, index) => {
      const matchingInventoryLogs = pastWeekInventoryLogs.filter((log) =>
        moment(log.createDate).isSame(day, 'day'),
      )
      let value: number
      if (pastWeekInventoryLogs.length === 0) {
        // No logs. Just fill in the graph with the current quantity
        value = this.props.defaultQuantity
      } else if (index === 0) {
        // First entry
        if (matchingInventoryLogs.length === 0) {
          // If no entry for the first day, get the value from the first entry that exists at all
          value = pastWeekInventoryLogs[0].previousValue
        } else {
          // If matching day entries exist, use the latest value from that day
          value = matchingInventoryLogs[matchingInventoryLogs.length - 1].newValue
        }
      } else if (matchingInventoryLogs.length > 0) {
        // If there is a log for the current day, use the latest value from that day
        value = matchingInventoryLogs[matchingInventoryLogs.length - 1].newValue
      } else {
        // Otherwise, inherit the value from previous entry
        value = dayData[dayData.length - 1].quantity
      }
      dayData.push({
        date: moment(day).format('YYYY-MM-DD'),
        quantity: value,
      })
    })

    // Find the minimum value for Y axis display purposes. Default 0.
    const minValue = dayData.reduce((min, data) => (data.quantity < min ? data.quantity : min), 0)

    return (
      <div className='mt-4 mb-4'>
        <Chart
          height={150}
          data={dayData}
          scale={{ date: { tickCount: 8 }, quantity: { min: minValue } }}
          forceFit
          padding='auto'
        >
          <Axis name='date' />
          <Axis name='quantity' />
          <Tooltip follow />
          <Geom type='area' position={`date*quantity`} color='#78C58D' />
        </Chart>
      </div>
    )
  }
}
